import {AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, signal, viewChild} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {WjNavModule, WjTabPanel} from '@mescius/wijmo.angular2.nav';
import {WorksheetsListComponent} from '../worksheets-list/worksheets-list.component';
import {RangesListComponent} from '../ranges-list/ranges-list.component';
import {CustomXmlListComponent} from '../custom-xml-list/custom-xml-list.component';
import {TablesListComponent} from '../tables-list/tables-list.component';
import {McpConnectorComponent} from "../mcp-connector/mcp-connector.component";
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import { AiChatComponent } from '../ai-chat/ai-chat.component';

interface TabItem {
    id: string
    header: string
    url: string
}

@Component({
    selector: 'app-main-tools',
    templateUrl: './main-tools.component.html',
    styleUrls: ['./main-tools.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        WjNavModule,
        WorksheetsListComponent,
        RangesListComponent,
        CustomXmlListComponent,
        TablesListComponent,
        McpConnectorComponent,
        AiChatComponent
    ],
    standalone: true
})
export class MainToolsComponent implements AfterViewInit {

    protected readonly compactMode = signal(true);

    tabItems: TabItem[] = [
        { id: 'sheets', header: 'Sheets', url: '/tools/worksheets' },
        { id: 'ranges', header: 'Ranges', url: '/tools/ranges' },
        { id: 'xml', header: 'XML', url: '/tools/customxml' },
        { id: 'workbook', header: 'Workbook', url: '/tools/workbook' },
    ];

    tabPanel = viewChild<WjTabPanel>('tabPanel');

    constructor(private el: ElementRef<HTMLElement>, private router: Router, private sanitizer: DomSanitizer) {
        router.events.subscribe(e => this.onRouteChange(e));
    }

    ngAfterViewInit(): void {
        this.activateCurrentTab(this.router.url);
    }

    protected tabLabel(fullLabel: string, faIconClass: string): SafeHtml {
        if (this.compactMode()) {
            const html = `<i class="fa ${faIconClass}"></i>`;
            return this.sanitizer.bypassSecurityTrustHtml(html);
        } else {
            return this.sanitizer.bypassSecurityTrustHtml(fullLabel);
        }
    }

    private activateCurrentTab(url: string) {
        if (this.tabPanel()) {
            const activeTabIdx = this.tabItems.findIndex(it => it.url === url);
             if (activeTabIdx >= 0) this.tabPanel().selectedIndex = activeTabIdx;
        }
    }

    onRouteChange(event) {
        if (event instanceof NavigationEnd) {
            console.log(event.url);
            this.activateCurrentTab(event.url);
        }
    }

    async test() {
        try {
            await Excel.run(async context => {
                /**
                 * Insert your Excel code here
                 */
                const range = context.workbook.getSelectedRange();

                // Read the range address
                range.load('address');

                // Update the fill color
                range.format.fill.color = 'yellow';

                await context.sync();
                alert(range.address);
                console.log(`The range address was ${range.address}.`);
            });
        } catch (error) {
            console.error(error);
        }
    }

    test2() {
        this.router.navigate(['./customxml']);
    }

    now(): string {
        return new Date().toLocaleDateString()
    }

    switchContent(event: any) {
        this.router.navigate(['.', event.value]);
    }

    /*
    // onTabSelected(event: SelectEventArgs) {
    //     this.router.navigate([this.tabItems[event.selectedIndex].url]);
    // }
    onSelectTab(event: MouseEvent, tabItem: TabItem) {
        event.preventDefault();
        event.stopPropagation();
        console.log('click on', tabItem);
        this.router.navigate([tabItem.url]);
    }

    onNewEvent($event: Event) {
        const activeid = this.tabsBarEl().nativeElement.activeid;
        console.log(activeid);
        const tabItem = this.tabItems.find(t => t.id === activeid);
        this.router.navigate([tabItem.url]);
    }*/

    protected onSelectedTabChange($event: any) {
        const idx = this.tabPanel()?.selectedIndex;
        // if (idx != null && idx >= 0) {
        //    this.router.navigate([this.tabItems[idx].url]);
        // }
    }

    protected toggleCompactMode() {
        this.compactMode.set(!this.compactMode());
    }
}
